import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { LuX } from "react-icons/lu";
import { Product } from "../../pages/product";
import { ProductModalContext } from "./context";
import "./style.css";

export const ProductModalProvider = ({ children }) => {
  const [slug, setSlug] = useState(null);
  const dialog = useRef(null);
  const trigger = useRef(null);
  const handoff = useRef(false);
  const location = useLocation();
  const closeProduct = useCallback(() => {
    if (dialog.current?.open) dialog.current.close();
    setSlug(null);
  }, []);
  const openProduct = useCallback(path => {
    trigger.current = document.activeElement;
    handoff.current = false;
    setSlug(decodeURIComponent(path.split("/").pop()));
  }, []);
  useEffect(() => { closeProduct(); }, [location.pathname, closeProduct]);
  useEffect(() => {
    if (!slug) return;
    const element = dialog.current;
    element.showModal();
    const html = document.documentElement;
    const previous = html.style.getPropertyValue("overflow-y");
    const priority = html.style.getPropertyPriority("overflow-y");
    html.style.setProperty("overflow-y", "hidden", "important");
    element.querySelector("button")?.focus();
    return () => {
      if (element.open) element.close();
      if (previous) html.style.setProperty("overflow-y", previous, priority); else html.style.removeProperty("overflow-y");
      if (!handoff.current && trigger.current?.isConnected) trigger.current.focus({ preventScroll: true });
    };
  }, [slug]);
  return <ProductModalContext.Provider value={{ openProduct, closeProduct }}>
    {children}
    <dialog ref={dialog} className="eats-product-modal" aria-label="Configurar producto"
      onCancel={event => { event.preventDefault(); closeProduct(); }} onClose={() => setSlug(null)}
      onPointerDown={event => {
        const rect = event.currentTarget.getBoundingClientRect();
        if (event.target === event.currentTarget && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) closeProduct();
      }}>
      {slug && <>
        <div className="eats-product-sheet-handle" aria-hidden="true"><span /></div>
        <button type="button" className="eats-product-modal-close" aria-label="Cerrar producto" onClick={closeProduct}><LuX aria-hidden="true" /></button>
        <Product key={slug} slug={slug} modal onAdded={() => { handoff.current = true; closeProduct(); }} />
      </>}
    </dialog>
  </ProductModalContext.Provider>;
};
